module.exports = __webpack_public_path__ + "img/icon--schedule.49294eb3.svg";